import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "sprout-ui-dom";
import { Box, Flex } from "sprout-ui-primitives";
import Dialog from "./Dialog";
const ActionConfirmationDialog = (props)=>{
    const { open , onRequestClose , title , content , confirmButtonText , onCancel , onConfirm , cancelButtonText ,  } = props;
    return /*#__PURE__*/ _jsx(Dialog, {
        variant: "confirmation",
        open: open,
        onRequestClose: onRequestClose,
        contextualTitle: title,
        children: /*#__PURE__*/ _jsxs(Box, {
            px: 3,
            pb: 5,
            children: [
                content,
                /*#__PURE__*/ _jsxs(Flex, {
                    mt: 3,
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "black",
                            height: "32px",
                            onClick: onCancel,
                            children: cancelButtonText
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            ml: 1,
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "bright-teal",
                                height: "32px",
                                onClick: onConfirm,
                                children: confirmButtonText
                            })
                        })
                    ]
                })
            ]
        })
    });
};
export default ActionConfirmationDialog;
